// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__-6K5W","col":"styles_col__2-oMh"};